import { render, staticRenderFns } from "./TableReceive.vue?vue&type=template&id=314740ec&"
import script from "./TableReceive.vue?vue&type=script&lang=js&"
export * from "./TableReceive.vue?vue&type=script&lang=js&"
import style0 from "./TableReceive.vue?vue&type=style&index=0&id=314740ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports